<script setup>
import { Head, router, usePage } from '@inertiajs/vue3'
import { getLocalizedUrl } from '@js/App/Plugins/LocalizedUrls'
import { onMounted, onUnmounted, ref } from 'vue'

const canonicalUrl = ref('')
const page = usePage()

const calcUrl = () => {
  if (!page.props.fullUrl) {
    return
  }

  try {
    const url = new URL(page.props.fullUrl)
    if (url?.href.includes('/welcome')) {
      canonicalUrl.value = getLocalizedUrl('welcome')
    } else {
      const newUrl = new URL(url.href)
      // clear search params
      newUrl.search = ''

      canonicalUrl.value = newUrl.toString()
    }
  } catch {
    // fullUrl is not a valid URL — skip canonical tag
  }
}

calcUrl()

let removeNavListener
onMounted(() => {
  removeNavListener = router.on('navigate', calcUrl)
})
onUnmounted(() => {
  removeNavListener?.()
})
</script>

<template>
  <Head>
    <link head-key="canonical" rel="canonical" :href="canonicalUrl">
  </Head>
</template>
